import createChainOfResponsibility from './createChainOfResponsibility';

import type { ComponentMiddleware } from './types';

export { createChainOfResponsibility };

export type { ComponentMiddleware };
